export default "/videos/7c68834afe7ef4d43982b96c8b77a177.mp4";